module.exports = __webpack_public_path__ + "static/media/Panorama-Fontana-di-Trevi.8aac0a3f.jpg";